var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline"},[_c('router-link',{attrs:{"to":"/profile"}},[_c('b-button',[_c('img',{attrs:{"height":"22","src":"man.svg"}}),_vm._v(" "+_vm._s(_vm.user.username)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }